
export const DifficultyScreen = () => `
        <div id="difficulty-screen" class="screen">
            <h2 class="screen-title">ZORLUK SEVİYESİ</h2>
            <div class="difficulty-options">
                <button class="gaddar-btn difficulty-btn" data-difficulty="kolay">
                    🐣 KOLAY
                    <small>Başlangıç için ideal.</small>
                </button>
                <button class="gaddar-btn difficulty-btn" data-difficulty="orta">
                    ⚖️ ORTA
                    <small>Kendine güvenenler.</small>
                </button>
                <button class="gaddar-btn difficulty-btn" data-difficulty="zor">
                    ☠️ ZOR
                    <small>Gerçek bir meydan okuma.</small>
                </button>
            </div>
        </div>
`;
